import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input", "container"]

  connect() {
    const container = this.containerTarget
    const initialValue = parseInt(container.dataset.starRatingValue, 10) || 5
    this.updateStars(initialValue)
  }

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.rating, 10)
    this.updateStars(rating)

    if (this.hasInputTarget) {
      this.inputTarget.value = rating
    }
  }

  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-yellow-400")
      } else {
        star.classList.remove("text-yellow-400")
        star.classList.add("text-gray-300")
      }
    })
  }
}
